import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../context/loginContext';
import { Card, Spin, message, Typography } from 'antd';
import axios from 'axios';

const { Title } = Typography;

const EmpresaSelection = () => {
  const { user, selectEmpresa } = useContext(LoginContext);
  
  const navigate = useNavigate();
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);

  // Configuración de estilos reutilizables
  const styles = {
    container: {
      minHeight: 'calc(100vh - 80px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px 16px 40px',
      background: '#f0f2f5',
      margin: '-20px',
      width: 'calc(100% + 40px)',
      boxSizing: 'border-box',
    },
    cardGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '24px',
      width: '100%',
      maxWidth: '1200px',
    },
    card: {
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(228, 155, 86, 0.42)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer',
      background: '#fff',
    },
    cardHover: {
      transform: 'scale(1.05)',
      boxShadow: '0 8px 24px rgba(228, 155, 86, 0.42)',
    },
    spinnerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh',
      width: '100%',
    },
  };

  // Cargar empresas al montar el componente
  useEffect(() => {
    if (!user || user.tiu_descripcion !== 'Administrador') {
      navigate('/');
      return;
    }

    const fetchEmpresas = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/usuarios/empresas/${user.usu_id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        setEmpresas(response.data);
      } catch (error) {
        message.error('Error al cargar las empresas');
      } finally {
        setLoading(false);
      }
    };

    fetchEmpresas();
  }, [user, navigate]);

  // Manejar selección de empresa

  const handleSelectEmpresa = (empresa) => {
    selectEmpresa(empresa); // Guardar empresa en el contexto
    navigate('/home-administrador');
  };

  return (
    <div style={styles.container}>
      <Title level={2} style={{ marginBottom: '32px', color: '#1a1a1a' }}>
        Selecciona una Empresa
      </Title>
      {loading ? (
        <div style={styles.spinnerContainer}>
          <Spin size="large" tip="Cargando empresas..." />
        </div>
      ) : (
        <div style={styles.cardGrid}>
          {empresas.map((empresa) => (
            <Card
              key={empresa.emp_id}
              title={empresa.emp_nombre}
              style={styles.card}
              bodyStyle={{ padding: '16px' }}
              hoverable
              onClick={() => handleSelectEmpresa(empresa)} // Corrección: usar emp_id
              onMouseEnter={(e) => {
                const target = e.currentTarget;
                target.style.transform = styles.cardHover.transform;
                target.style.boxShadow = styles.cardHover.boxShadow;
              }}
              onMouseLeave={(e) => {
                const target = e.currentTarget;
                target.style.transform = 'scale(1)';
                target.style.boxShadow = styles.card.boxShadow;
              }}
            >
              {/* Aquí podrías agregar más detalles de la empresa si quisieras */}
              <p style={{ color: '#666', margin: 0 }}>
                ID: {empresa.emp_id}
              </p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmpresaSelection;